<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'PBRInterfaceList' }"
                ><i class="fas fa-chevron-left"></i> </router-link
              >PBR Interface
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">PBR Interface</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <div class="card-header py-3">
                <h3 class="card-title">Detail</h3>
              </div>
              <div class="card-body">
                <div class="custom-list">
                  <ul>
                    <li><strong>ID</strong> {{ value.id }}</li>

                    <li>
                      <strong>Available Interface</strong>
                      {{ value.interface_name }}
                    </li>

                    <li>
                      <strong>PBR-Map Name</strong> {{ value.pbr_map_id }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from '@/services/api'
import axios from 'axios'
const fileDownload = require('js-file-download')
import { Notification } from 'element-ui'

export default {
  name: 'PBRInterfaceShow',
  metaInfo: {
    title: 'PBR Interface | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/pbr_interfaces/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
